export default __webpack_public_path__ + "static/media/flash-auto.478213fa.svg";